
import { Component, Prop, Vue } from 'vue-property-decorator'

@Component({})
export default class BacBigButton extends Vue {
  @Prop({ default: '' }) bigText!: string
  @Prop({ default: '' }) smallText!: string
}
